import { z } from 'zod';
import { sfaaCodeId } from '../../types/opaque.mjs';
import { emptyToUndefined } from '../../utils/empty-to-undefined.util.mjs';

const optionalQueryString = z.preprocess(emptyToUndefined, z.string().optional());
var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.object({
            id: sfaaCodeId,
            code: z.string(),
            label: z.string(),
            type: z.string(),
            subType: z.string(),
            class: z.string(),
            subClass: z.string(),
            obligeeType: z.string().nullable(),
        });
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
const recentlyUsedSuretyTypeDef = ["contract", "commercial"];
var List;
(function (List) {
    (function (Request) {
        Request.schema = z.object({
            type: optionalQueryString,
            subType: optionalQueryString,
            class: optionalQueryString,
            subClass: optionalQueryString,
        });
    })(List.Request || (List.Request = {}));
    (function (Response) {
        Response.schema = z.array(Get.Response.schema);
    })(List.Response || (List.Response = {}));
})(List || (List = {}));
var RecentlyUsed;
(function (RecentlyUsed) {
    RecentlyUsed.suretyTypeSchema = z.enum(recentlyUsedSuretyTypeDef);
    (function (Request) {
        Request.schema = z.object({
            suretyType: RecentlyUsed.suretyTypeSchema,
        });
    })(RecentlyUsed.Request || (RecentlyUsed.Request = {}));
})(RecentlyUsed || (RecentlyUsed = {}));

export { Get, List, RecentlyUsed };
